import { render, staticRenderFns } from "./TopItemsCard.vue?vue&type=template&id=32f740ca&"
import script from "./TopItemsCard.vue?vue&type=script&lang=js&"
export * from "./TopItemsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports